<div class="page">

  <div class="pagehead">
    <div>
      <h1>Move to distributor</h1>
      <p>Send wallet balance up the chain — pick the distributor, then confirm with an OTP</p>
    </div>
  </div>

  <div class="row-2-1">
    <div class="card">
      <div class="clabel"><svg viewBox="0 0 24 24"><path d="M3 12h14M13 6l6 6-6 6"/></svg>Transfer details</div>
      <form [formGroup]="form" class="kit-form">
        <div class="er-field er-field--amount" [class.has-error]="isFieldInvalid('amount')">
          <label class="er-field__label" for="m2d-amount">Amount <span class="req">*</span></label>
          <div class="er-field__wrap">
            <span class="er-field__affix">₹</span>
            <input id="m2d-amount" class="er-field__control" type="number" formControlName="amount"
              placeholder="0" required>
          </div>
          <div class="er-field__help">Eligible amount {{ walletAmount | erInr }}</div>
          <div class="er-field__error" *ngIf="isFieldInvalid('amount')">Enter the amount</div>
        </div>

        <div class="er-field" [class.has-error]="isFieldInvalid('comments')">
          <label class="er-field__label" for="m2d-remark">Remark <span class="req">*</span></label>
          <div class="er-field__wrap">
            <input id="m2d-remark" class="er-field__control" formControlName="comments"
              placeholder="Purpose of the transfer" required>
          </div>
          <div class="er-field__error" *ngIf="isFieldInvalid('comments')">Enter a remark</div>
        </div>

        <div class="form-actions">
          <button type="button" class="er-btn er-btn--primary" (click)="sendOTP(content);"
            *ngIf="!isValidOtp && !isSubmit">Move to distributor</button>
        </div>
      </form>
    </div>

    <div class="card">
      <div class="clabel"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21v-1a6 6 0 0112 0v1"/></svg>Select your distributor</div>
      <ng-container *ngFor="let item of entities; let i = index">
        <div class="dis" *ngIf="item.l1" [class.is-picked]="isChecked"
          (click)="isChecked ? selectDis2(item,'L1') : selectDis(item,'L1')" role="button" tabindex="0">
          <span class="dis-check"><i class="fa" [class.fa-square-o]="!isChecked" [class.fa-check-square-o]="isChecked" aria-hidden="true"></i></span>
          <span class="dis-body">
            <span class="dis-name">{{ item.l1.distibutorName }}</span>
            <span class="dis-meta mono">{{ item.l1.uniqueName }} · {{ item.l1.phoneNumber }}</span>
          </span>
        </div>
        <div class="dis" *ngIf="item.l2" [class.is-picked]="isCheckedl2"
          (click)="isCheckedl2 ? selectDis2(item,'L2') : selectDis(item,'L2')" role="button" tabindex="0">
          <span class="dis-check"><i class="fa" [class.fa-square-o]="!isCheckedl2" [class.fa-check-square-o]="isCheckedl2" aria-hidden="true"></i></span>
          <span class="dis-body">
            <span class="dis-name">{{ item.l2.distibutorName }}</span>
            <span class="dis-meta mono">{{ item.l2.uniqueName }} · {{ item.l2.phoneNumber }}</span>
          </span>
        </div>
        <div class="dis" *ngIf="item.l3" [class.is-picked]="isCheckedl3"
          (click)="!isCheckedl3 && selectDis(item,'L3')" role="button" tabindex="0">
          <span class="dis-check"><i class="fa" [class.fa-square-o]="!isCheckedl3" [class.fa-check-square-o]="isCheckedl3" aria-hidden="true"></i></span>
          <span class="dis-body">
            <span class="dis-name">{{ item.l3.distibutorName }}</span>
            <span class="dis-meta mono">{{ item.l3.uniqueName }} · {{ item.l3.phoneNumber }}</span>
          </span>
        </div>
      </ng-container>
    </div>
  </div>

</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header er-modal-head">
    <h6 class="modal-title" id="modal-basic-title">OTP sent to {{ retailor_phoneNumber }}</h6>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="otpform">
      <div class="er-field otp-field" [class.has-error]="isOtpFieldInvalid('otp')">
        <div class="er-field__wrap">
          <input class="er-field__control otp-input" type="text" placeholder="······"
            (keypress)="numberOnly($event)" minlength="6" maxlength="6" formControlName="otp" required>
        </div>
        <div class="er-field__error" *ngIf="isOtpFieldInvalid('otp')">Enter the 6-digit OTP</div>
      </div>
    </form>
    <countdown [config]="{leftTime:180}" *ngIf="!isResendEnable" (event)="handleEvent($event)">$!m!:$!s!</countdown>
  </div>
  <div class="modal-footer">
    <button (click)="resendOTP()" *ngIf="isResendEnable" class="er-btn er-btn--ghost">Resend</button>
    <button class="er-btn er-btn--primary" (click)="validateOTP(otpform.value,'content')">Submit</button>
  </div>
</ng-template>

